<mat-form-field [formGroup]="formGroup" [appearance]="appearance">
  <ngx-mat-file-input [id]="id" [formControl]="control" [valuePlaceholder]="'uploadFile' | translate">
  </ngx-mat-file-input>
  <mat-icon matSuffix>folder</mat-icon>
  <mat-error class="mat-error" *ngIf="isControlInvalid()">
    <ng-container *ngIf="getErrorMessage() as errorLabel">
      {{errorLabel.label | translate:errorLabel.parameters }}
    </ng-container>
  </mat-error>
</mat-form-field>
